import { Typography } from "@joonapp/web-shared"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import useOnboardContext from "../../hooks/useOnboardContext"
import { useQuestionnairesQuery } from "../../networking/queries"
import { getUserReasons } from "../../util/util"

const ParentSignupReasons = () => {
  const [userReasons, setUserReasons] = useState<any>(null)
  const { parentData } = useOnboardContext()
  const { data: questionsResponse, status } = useQuestionnairesQuery()
  const { t } = useTranslation()

  useEffect(() => {
    if (!questionsResponse?.parentQuestions) return
    const reasons = getUserReasons(
      parentData,
      questionsResponse.parentQuestions
    )
    setUserReasons(reasons)
    // eslint-disable-next-line
  }, [questionsResponse])

  if (!userReasons || status === "loading") return <div></div>

  // Answer id 67 is the "Something else" option; hide the secondary goal when
  // it's that, or a duplicate of the primary. Checking the id (not the text)
  // keeps this working when the answer copy is translated.
  const hideSecondaryGoal =
    userReasons[0].text === userReasons[1].text || userReasons[1].id === 67

  return (
    <div className="flex flex-col gap-1 w-full">
      <Typography variant="bodySmallBold" textAlign="center">
        {t("PAYWALL_PRIMARY_GOAL")}
      </Typography>
      <div className="signup-reason flex flex-col items-center gap-1 bg-backgroundPrimary">
        {<img src={userReasons[0].icon} alt="icon" />}
        <Typography variant="bodySmallBold" textAlign="center">
          {userReasons[0].text}
        </Typography>
      </div>
      {!hideSecondaryGoal && (
        <>
          <Typography variant="bodySmallBold" textAlign="center">
            {t("PAYWALL_SECONDARY_GOAL")}
          </Typography>
          <div className="signup-reason flex flex-col items-center gap-1 bg-backgroundPrimary">
            {<img src={userReasons[1].icon} alt="icon" />}
            <Typography variant="bodySmallBold" textAlign="center">
              {userReasons[1].text}
            </Typography>
          </div>
        </>
      )}
    </div>
  )
}

export default ParentSignupReasons
